import isExperienceEditor from "@utils/is-experience-editor";

var VCA = VCA || {};


VCA.Stats = (function ($) {

    var ui = {};
    var MEDIA_QUERY = '(max-width: 767px)';
    var mql = window.matchMedia(MEDIA_QUERY);
    var started = false;

    function init() {
        setTextTwoActive();
        bindTextHover();
        cacheUI();
        initStatMobileSlider();
    }

    function cacheUI() {
        ui.$body = $('body');
        ui.$statsSlider = $('.js-stat-row');
    }

    function bindTextHover() {
        $(document).on('mouseover', '.stats__item', function (e) {
            var element = $(this);
            var isActive = $(this);
            e.stopPropagation();
            if (!started) {
                if (!mql.matches && !$(this).hasClass('active')) {
                    started = true;
                    var targetID = $(this).attr("data-text");
                    var $target = $('.js-item-text[data-peek="' + targetID + '"]');
                    $('.js-interactive-text').removeClass('active');
                    $(this).children('.js-interactive-text').addClass('active');
                    $('.js-item-text').fadeOut("fast").promise().done(function () {
                        $target.fadeIn("fast");
                        started = false;
                    });
                }
            }
        });
    }

    function initStatMobileSlider() {
        if (mql.matches) {
            var statsSlider = ui.$statsSlider.each(function (index, element) {
                $(this).addClass('js-stat-row' + index);
                var item_length = $('.js-stat-row' + index + ' > div').length;
                var startItem = 0;
                if ($(this).hasClass('js-stats-interactive')) {
                    startItem = 1;
                }
                if (item_length > 1 && !isExperienceEditor) {
                    $('.js-stat-row' + index).slick({
                        autoplay: false,
                        infinite: false,
                        arrows: false,
                        dots: true,
                        initialSlide: startItem,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: true,
                        focusOnChange: true,
                        accessibility: true,
                        mobileFirst: true,
                        responsive: [{
                            breakpoint: 767,
                            settings: "unslick"
                        }]
                    });
                }
            });
        }
    }

    function setTextTwoActive() {
        if (!mql.matches) {
            $('[data-text="text-two"]').children('.js-interactive-text').addClass('active');
            $('.js-item-text[data-peek="text-two"]').fadeIn("fast");
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.Stats.init();
});